import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-windows",
  "use": "icon-windows-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"none\" id=\"icon-windows\">\n<path d=\"M16.9297 3.23145L9.30481 4.34838V9.89524H16.9295L16.9297 3.23145ZM3.23071 5.23757V9.89524H8.76742V4.42677L3.23071 5.23757ZM3.23071 15.1513L8.76742 15.9713V10.4343H3.23071V15.1513ZM16.9297 17.1802V10.4343H9.30481V16.0511L16.9297 17.1802Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol